<div class="d-flex align-items-start g-g">
  <form
    [formGroup]="bandwidthOptionsForm"
    (ngSubmit)="addBandwidthOption()"
    class="d-flex align-items-center g-g w-50"
  >
    <div class="flex-fill">
      <input
        type="number"
        formControlName="bandwidth"
        class="form-control primary-lighter config-control"
        placeholder="e.g. 70"
      />
    </div>
    <button
      type="submit"
      [disabled]="bandwidthOptionsForm.invalid"
      class="btn btn-success"
    >
      <i class="fa-solid fa-circle-plus"></i>
      <i class="fa-solid fa-caret-right"></i>
    </button>
  </form>

  <ul
    class="flex-fill d-flex flex-column g-g bandwidth-subsection align-self-stretch"
  >
    <!-- Default -->
    @for (
      bandwidth of defaultBandwidthOptions;
      track bandwidth;
      let i = $index
    ) {
      <li
        class="d-flex align-items-center g-g justify-content-between bandwidth-option default"
      >
        <div class="bandwidth-type">
          Bandwidth
          <span class="bandwidth-config-property-value"
            >{{ bandwidth }} MHz</span
          >
        </div>
        <span>default</span>
      </li>
    }
    <!-- Custom -->
    @for (
      bandwidth of editableBandwidthOptions;
      track bandwidth;
      let i = $index
    ) {
      <li
        class="d-flex align-items-center g-g justify-content-between bandwidth-option"
      >
        <div class="bandwidth-type">
          Bandwidth
          <span class="bandwidth-config-property-value"
            >{{ bandwidth }} MHz</span
          >
        </div>
        <button (click)="removeBandwidthOption(i)" class="remove-button">
          <i class="fa-solid fa-trash"></i>
        </button>
      </li>
    }
  </ul>
</div>
